import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { selectAllOptions } from "../customisation-slice";
import PropTypes from "prop-types";
import { getProductVariantsFromShopify } from "../services/shopify";
import { useDialogContext } from "./dialog-provider";
import { DialogTypes } from "../constants/dialog-types";
import { useSelector } from "react-redux";

const propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export const ProductVariantContext = createContext([]);

export const useProductVariantContext = () => useContext(ProductVariantContext);

export const ProductVariantProvider = ({ children }) => {
  const [productVariants, setProductVariants] = useState([]);
  const [loadingVariants, setloadingVariants] = useState(true);
  const { openDialog } = useDialogContext();
  const currentCustomiserState = useSelector(selectAllOptions);

  const getProducts = useCallback(async () => {
    try {
      const variants = await getProductVariantsFromShopify();
      setProductVariants(variants);
      setloadingVariants(false);
    } catch (error) {
      console.log("Error communicating with Shopify");
      openDialog({
        type: DialogTypes.ERROR,
        title: "Error!",
        description:
          "An error has occured whilst loading the customiser, please reload the page and try again.",
        onSubmit: () => window.location.reload(),
        submitButtonProps: {
          label: "Reload",
        },
        showCloseButton: false,
      });
    }
  }, [openDialog]);

  useEffect(() => {
    getProducts();
  }, [getProducts]);

  const getCurrentProductVariant = () => {
    let key =
      currentCustomiserState.case.selected === "titanium"
        ? "Titanium"
        : "Default";

    return productVariants.find((variant) => variant.title === key);
  };

  return (
    <ProductVariantContext.Provider
      value={{ getCurrentProductVariant, loadingVariants }}
    >
      {children}
    </ProductVariantContext.Provider>
  );
};

ProductVariantProvider.propTypes = propTypes;

export default ProductVariantProvider;
